<template>
  <div
    :class="containerClass ? containerClass : 'flex flex-col gap-3 items-end '"
  >
    <span v-if="label" :class="labelClass">
      {{ label }}
    </span>
    <div :class="listClass">
      <a
        v-for="item in items"
        :key="item.label"
        :href="item.href"
        target="_blank"
        rel="noopener noreferrer"
        :class="linkClass"
        :aria-label="item.label"
      >
        <svg
          :class="iconClass"
          :viewBox="item.viewBox"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path v-for="(path, index) in item.paths" :key="index" :d="path" />
        </svg>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
interface SocialLink {
  label: string;
  href: string;
  viewBox: string;
  paths: string[];
}

interface Props {
  label?: string;
  items?: SocialLink[];
  containerClass?: string;
  labelClass?: string;
  listClass?: string;
  linkClass?: string;
  iconClass?: string;
}

withDefaults(defineProps<Props>(), {
  label: "Suivez-nous",
  items: () => [
    {
      label: "Facebook",
      href: "https://www.facebook.com/TaybaTravelBE",
      viewBox: "0 0 20 20",
      paths: [
        "M0 9.99863C0.00116354 14.918 3.5784 19.1067 8.437 19.8776V12.8886H5.9V9.99863H8.44V7.79863C8.32645 6.75617 8.68252 5.71722 9.41164 4.96356C10.1408 4.2099 11.1674 3.81964 12.213 3.89863C12.9635 3.91075 13.7122 3.97759 14.453 4.09863V6.55763H13.189C12.7538 6.50063 12.3164 6.64435 11.9998 6.94829C11.6832 7.25224 11.5218 7.68351 11.561 8.12063V9.99863H14.332L13.889 12.8896H11.561V19.8776C16.8155 19.0472 20.5001 14.2484 19.9455 8.9577C19.3909 3.667 14.7913 -0.263445 9.47882 0.0138048C4.16636 0.291054 0.000844477 4.67893 0 9.99863Z",
      ],
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/tayba_travel/",
      viewBox: "0 0 19 19",
      paths: [
        "M9 18.036C6.54 18.036 6.25 18.023 5.29 17.981C4.54137 17.9564 3.80243 17.8042 3.105 17.531C1.89831 17.0614 0.94414 16.1069 0.475 14.9C0.212306 14.2 0.0706179 13.4605 0.056 12.713C0 11.755 0 11.441 0 9C0 6.533 0.013 6.245 0.056 5.29C0.0709376 4.54352 0.212621 3.80501 0.475 3.106C0.943631 1.89753 1.89935 0.942172 3.108 0.474C3.80664 0.210202 4.54535 0.0681443 5.292 0.054C6.247 0 6.561 0 9 0C11.48 0 11.765 0.013 12.71 0.054C13.4586 0.0682666 14.1992 0.21031 14.9 0.474C16.1083 0.942703 17.0638 1.89788 17.533 3.106C17.8001 3.81519 17.9426 4.56525 17.954 5.323C18.01 6.281 18.01 6.594 18.01 9.034C18.01 11.474 17.996 11.794 17.954 12.741C17.9391 13.4892 17.7971 14.2294 17.534 14.93C17.0637 16.1377 16.1081 17.0926 14.9 17.562C14.2002 17.8242 13.4611 17.9659 12.714 17.981C11.759 18.036 11.446 18.036 9 18.036ZM8.966 1.583C6.52 1.583 6.266 1.595 5.311 1.638C4.74098 1.64555 4.17648 1.75074 3.642 1.949C2.85275 2.25101 2.22823 2.87299 1.923 3.661C1.72321 4.2013 1.61801 4.77198 1.612 5.348C1.559 6.317 1.559 6.571 1.559 9C1.559 11.4 1.568 11.691 1.612 12.654C1.62095 13.2242 1.7261 13.7888 1.923 14.324C2.22868 15.1115 2.85309 15.733 3.642 16.035C4.17611 16.2346 4.74085 16.3398 5.311 16.346C6.279 16.402 6.534 16.402 8.966 16.402C11.419 16.402 11.673 16.39 12.62 16.346C13.1904 16.3391 13.7553 16.2339 14.29 16.035C15.0745 15.7304 15.6949 15.1103 16 14.326C16.1994 13.7852 16.3046 13.2143 16.311 12.638H16.322C16.365 11.682 16.365 11.427 16.365 8.984C16.365 6.541 16.354 6.284 16.311 5.329C16.302 4.75945 16.1969 4.19551 16 3.661C15.6956 2.87557 15.0751 2.25429 14.29 1.949C13.7555 1.74974 13.1904 1.64452 12.62 1.638C11.653 1.583 11.4 1.583 8.966 1.583ZM9 13.619C7.12999 13.6202 5.44342 12.4947 4.72686 10.7675C4.01031 9.04018 4.40491 7.05133 5.72663 5.72846C7.04836 4.40559 9.03686 4.00927 10.7648 4.72433C12.4927 5.43939 13.6196 7.12499 13.62 8.995C13.6172 11.5461 11.5511 13.614 9 13.619ZM9 5.993C7.34315 5.993 6 7.33615 6 8.993C6 10.6499 7.34315 11.993 9 11.993C10.6569 11.993 12 10.6499 12 8.993C11.9962 7.33774 10.6553 5.99685 9 5.993ZM13.8 5.28C13.2054 5.27779 12.7249 4.79459 12.726 4.20001C12.7271 3.60543 13.2094 3.12401 13.804 3.12401C14.3986 3.12401 14.8809 3.60542 14.882 4.2C14.8823 4.48686 14.7683 4.76202 14.5653 4.96468C14.3622 5.16733 14.0869 5.2808 13.8 5.28Z",
      ],
    },
    {
      label: "TikTok",
      href: "https://www.tiktok.com/@tayba_travel",
      viewBox: "0 0 20 23",
      paths: [
        "M10.2643 0.0187501C11.4921 7.12462e-08 12.7108 0.00975 13.9288 0C13.9693 1.52325 14.5873 2.89425 15.5706 3.90975L15.5691 3.90825C16.6273 4.8615 18.0043 5.4795 19.5223 5.5845L19.5433 5.586V9.363C18.1093 9.327 16.7608 8.99625 15.5451 8.42775L15.6066 8.45325C15.0186 8.1705 14.5213 7.88025 14.0488 7.55625L14.0878 7.58175C14.0788 10.3185 14.0968 13.0553 14.0691 15.7823C13.9918 17.172 13.5298 18.4395 12.7888 19.4977L12.8038 19.4745C11.5648 21.249 9.55784 22.4138 7.27559 22.4827H7.26509C7.17284 22.4873 7.06409 22.4895 6.95459 22.4895C5.65709 22.4895 4.44434 22.128 3.41084 21.5002L3.44084 21.5175C1.55984 20.3857 0.262344 18.4493 0.0223438 16.197L0.0193439 16.1663C0.000593852 15.6975 -0.00840621 15.2288 0.0103438 14.7698C0.377844 11.1855 3.38084 8.41275 7.03109 8.41275C7.44134 8.41275 7.84334 8.448 8.23409 8.51475L8.19209 8.50875C8.21084 9.8955 8.15459 11.283 8.15459 12.6698C7.83734 12.555 7.47134 12.4883 7.08959 12.4883C5.68859 12.4883 4.49684 13.3838 4.05584 14.634L4.04909 14.6565C3.94934 14.9767 3.89159 15.345 3.89159 15.726C3.89159 15.8805 3.90134 16.0335 3.91934 16.1835L3.91784 16.1655C4.16684 17.7 5.48234 18.858 7.06859 18.858C7.11434 18.858 7.15934 18.8573 7.20434 18.855H7.19759C8.29484 18.822 9.24734 18.2318 9.78584 17.3595L9.79334 17.346C9.99359 17.067 10.1308 16.7295 10.1766 16.3627L10.1773 16.3522C10.2711 14.6745 10.2336 13.0065 10.2426 11.3287C10.2516 7.55175 10.2336 3.78375 10.2613 0.0165001L10.2643 0.0187501Z",
      ],
    },
  ],
  containerClass: "",
  labelClass:
    "text-white/60 text-xs font-medium font-outfit uppercase tracking-[0.48px] leading-[14px]",
  listClass: "flex items-center gap-3",
  linkClass: "text-white hover:text-white/70 transition-colors w-6 h-6 p-0.5",
  iconClass: "w-full h-full ",
});
</script>
